import Axios from "axios"
import { AppStats } from "../models/AppStats"
import { SkResponse } from "../models/SkResponse"
import { MakeUrl } from "./Urls"

export const GetAppStatsAction = async (): Promise<SkResponse<AppStats>> => { return await Axios.get(MakeUrl('/admin/app-stats')) }